export class ShareMultiplePatientModal{
    constructor(
        private sharePatients:any[],
        private eaLogId:string
    ) {}
}
